import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 2],
        rowsSize: [0, 0],
        rowSpan: {
          "0:1": 2,
        },
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide03-review-image01.svg`,
                    styles: {
                      height: "266px",
                    },
                  },
                },
              },
            },
            {
              variant: "layout",
              data: {
                type: "table",
                options: {
                  cols: 2,
                  rows: 5,
                  colSpan: {
                    "4:0": 2,
                  },
                  rowsSize: [1, 0, 1, 0, 0],
                  components: [
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-review-image02.svg`,
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-review-image03.svg`,
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-review-adequate.wav`,
                              text: "Adequate Recording",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-review-non-ideal-distance.wav`,
                              text: "Non-Ideal HATS distance",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-review-image04.svg`,
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-review-image05.svg`,
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-review-noisy.wav`,
                              text: "Noisy Recording",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-review-non-ideal-orientation.wav`,
                              text: "Non-Ideal HATS orientation",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-review-image06.svg`,
                            },
                          },
                          styles: {
                            height: "34px",
                          },
                        },
                      },
                    ],
                  ],
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "After recording, some time is usually allocated to reviewing and selecting recordings which convey all the required information for psychoacoustic and perceptual analysis. This process typically means listening (using a calibrated playback device) aided by time and frequency domain representations (e.g. spectrograms). If multiple repetitions or long recordings were made, specific sections might need to be extracted by editing (i.e. cutting) individual tracks. The length of the selected stimuli should be considered carefully since long and transient stimuli can be hard to evaluate for participants and can increase the overall length of a jury test. If different states can be evaluated separately without losing context, this can be a valid approach.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                    },
                  },
                },
                styles: {
                  width: "93%",
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
